module.exports = __webpack_public_path__ + "static/media/circle.b34e68e6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/circle.svg
// module id = 255
// module chunks = 0